import React from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Locales from "./locales"; // Component Locales đã định nghĩa trước
import CaptivePortal from "./components/CaptivePortal";
import { pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();

function App() {
  return (
    <div className="App">
      <Locales>
        <Router>
          <Routes>
            <Route path="/" element={<CaptivePortal />} />
          </Routes>
        </Router>
      </Locales>
    </div>
  );
}

export default App;
